const HTML_TAG_REGEX = /<\s*\/?\s*[a-z][a-z0-9]*(?:\s[^>]*)?\s*>/i;
const EVENT_HANDLER_REGEX = /\bon[a-z]+\s*=/i;
const JS_URI_REGEX = /javascript\s*:/i;
const CSV_INJECTION_REGEX = /^[+\-@=]/;
const CONTROL_CHAR_REGEX = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g;
const PHONE_LEADING_FORBIDDEN_REGEX = /^[\-@=]/;

export const PHONE_DISPLAY_PATTERN = /^\+?[0-9\s\-()]*$/;

export const sanitizeInput = (value) => {
  if (value == null) return "";
  return String(value).trim().replace(CONTROL_CHAR_REGEX, "");
};

export const collapseSpaces = (value) => {
  if (!value) return value;
  return value.replace(/\s{2,}/g, " ");
};

/** Digits-only phone for persistence. */
export const normalizePhone = (value) => String(value || "").replace(/\D/g, "");

export const hasPhoneLeadingForbidden = (value) => {
  if (!value) return false;
  return PHONE_LEADING_FORBIDDEN_REGEX.test(value);
};

export const containsDangerousHtml = (value) => {
  if (!value) return false;
  return (
    HTML_TAG_REGEX.test(value) ||
    EVENT_HANDLER_REGEX.test(value) ||
    JS_URI_REGEX.test(value)
  );
};

export const hasCSVInjectionChar = (value) => {
  if (!value) return false;
  return CSV_INJECTION_REGEX.test(value);
};

export const validateSecureText = (value, label) => {
  if (!value || !value.trim()) return null;
  const sanitized = sanitizeInput(value);
  if (hasCSVInjectionChar(sanitized)) {
    return `${label} must not start with +, -, @, or =`;
  }
  if (containsDangerousHtml(sanitized)) {
    return `${label} must not contain HTML tags, scripts, or event handlers`;
  }
  return null;
};

const NAME_PATTERN = /^[a-zA-Z\s'\-.]+$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateNameText = (value, label, max = 50) => {
  if (!value || !String(value).trim()) return null;
  const sanitized = sanitizeInput(value);
  if (hasCSVInjectionChar(sanitized)) {
    return `${label} must not start with +, -, @, or =`;
  }
  if (containsDangerousHtml(sanitized)) {
    return `${label} must not contain HTML tags, scripts, or event handlers`;
  }
  if (!NAME_PATTERN.test(sanitized)) {
    return `${label} can only contain letters, spaces, apostrophe, hyphen, and period`;
  }
  if (sanitized.length > max) {
    return `${label} must be at most ${max} characters`;
  }
  return null;
};

export const validateEmailText = (value, label = "Email") => {
  const sanitized = sanitizeInput(value);
  if (!sanitized) {
    return "Invalid email address";
  }
  if (hasCSVInjectionChar(sanitized)) {
    return `${label} must not start with +, -, @, or =`;
  }
  if (containsDangerousHtml(sanitized)) {
    return `${label} must not contain HTML tags, scripts, or event handlers`;
  }
  if (sanitized.length > 254) {
    return `${label} must be at most 254 characters`;
  }
  if (!EMAIL_PATTERN.test(sanitized)) {
    return "Invalid email address";
  }
  return null;
};
